import { useState } from 'react';
import { Icon } from '../../../layout/Icon.jsx';
import { PlatformModal } from './PlatformModal.jsx';
import { copyText } from '../platformApi.js';
import { toast } from '../../../shared/useToast.js';

function Secret({ label, value }) {
  return (
    <div className="rounded-[10px] border border-line p-2.5">
      <div className="text-[11.5px] text-ink-3 mb-1">{label}</div>
      <div
        className="font-mono font-extrabold text-[20px] break-all select-all"
        dir="ltr"
        style={{ textAlign: 'left' }}
      >
        {value || '—'}
      </div>
    </div>
  );
}

/**
 * نافذة بيانات الدخول — تُعرض بعد الموافقة / الإنشاء مع تفعيل / إعادة ضبط كلمة المرور.
 * هذه المرّة الوحيدة التي تظهر فيها كلمة المرور، ولا تُغلق إلا بـ «تم الحفظ».
 */
export function CredentialsModal({ credentials, title = 'بيانات دخول المالك', sub, onDone }) {
  const [copied, setCopied] = useState(false);
  const company = credentials?.company || '';
  const username = credentials?.username || '';
  const password = credentials?.password || '';

  async function copyAll() {
    const text = [
      'كود الشركة: ' + company,
      'اسم المستخدم: ' + username,
      'كلمة المرور: ' + password
    ].join('\n');
    const ok = await copyText(text);
    if (!ok) {
      toast.error('تعذّر النسخ — انسخ البيانات يدوياً');
      return;
    }
    setCopied(true);
    toast.success('تم نسخ بيانات الدخول');
  }

  return (
    <PlatformModal
      title={title}
      sub={sub || 'سلّم هذه البيانات لمالك الشركة'}
      width={460}
      footer={(
        <>
          <button type="button" className="btn flex-1 justify-center" onClick={copyAll}>
            {copied ? <Icon name="check" size={14} /> : null}
            {copied ? 'تم نسخ البيانات' : 'نسخ البيانات'}
          </button>
          <button type="button" className="btn btn-primary flex-1 justify-center" onClick={onDone}>
            <Icon name="check" size={14} /> تم الحفظ
          </button>
        </>
      )}
    >
      <div
        className="rounded-[10px] p-2.5 text-[12.5px] font-semibold flex items-start gap-2"
        style={{ background: '#FEE2E2', color: '#B91C1C' }}
      >
        <Icon name="bell" size={16} />
        <span>
          انسخ كلمة المرور الآن — لن تُعرض مرّة أخرى بعد إغلاق هذه النافذة.
          إن فُقدت فالحل الوحيد هو «إعادة ضبط كلمة مرور المالك».
        </span>
      </div>

      <Secret label="كود الشركة (يُكتب في شاشة الدخول)" value={company} />
      <Secret label="اسم المستخدم" value={username} />
      <Secret label="كلمة المرور" value={password} />

      <div className="text-[11.5px] text-ink-3">
        يُفضّل أن يغيّر المالك كلمة المرور بعد أول دخول من شاشة «المستخدمون» داخل نظام شركته.
      </div>
    </PlatformModal>
  );
}
